import { sort } from '../../utils/helpers';
import actionHelpers from '../../utils/action-helpers';
import getterHelpers from '../../utils/getter-helpers';
import mutationHelpers from '../../utils/mutation-helpers';
import axios from 'axios';
const path = process.env.VUE_APP_ROOT_API;

const state = {
  status: null,
  items: [],
  nextUrl: null,
  heading: 'Herds',
  total: null,
  errors: [],
  filters: {
    visibility: []
  },
  displayStyle: 'grid',
  sort: {
    direction: 'asc',
    field: 'name'
  }
};

const getters = {
  getById: state => id => {
    return state.items.find(o => {
      return o.id === parseInt(id, 10);
    });
  },
  getByUserId: state => userId => {
    return state.items.find(o => {
      return o.id === userId;
    });
  },
  ...getterHelpers
};

const actions = {
  RESET_ERRORS: actionHelpers.RESET_ERRORS,
  RESET_STATUS: actionHelpers.RESET_STATUS,
  CLEAR_ITEMS: ({ commit }) => {
    commit('CLEAR_ITEMS');
  },
  FETCH_ALL: ({ commit, dispatch }, payload) => {
    // fetch an initial list of herds
    commit('CLEAR_ITEMS');

    const sort = () =>
      dispatch('SORT', {
        direction: state.sort.direction,
        field: state.sort.field
      });

    actionHelpers.FETCH_ALL(`${path}/api/herds/${payload.num}`, sort)({
      commit,
      dispatch
    });
  },
  FETCH_MORE: ({ commit, dispatch }) => {
    // fetch the next page of accessories if there is a next page
    actionHelpers.FETCH_MORE(state.nextUrl)({ commit, dispatch });
  },
  FETCH: async ({ commit, dispatch }, { id }) => {
    if (id) {  
      try {
        commit('UPDATE_STATUS', 'loading');
        const { data: { item: herd } } = await axios.get(`${path}/api/user/${id}/herd`);

        commit('UPDATE_STATUS', 'success');
        commit('ADD_ITEM', herd);
  
        return herd;
      } catch (error) {
        console.error(error);
        commit('UPDATE_STATUS', 'error');
        dispatch(
          'notification/ERROR_NOTIFICATION',
          'could not fetch item. try again later.',
          { root: true }
        );
      }
    } else {
      console.error('you are not logged in.');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'please log in to view your collection',
        { root: true }
      );
    }
  },
  UPDATE: async ({ commit, dispatch }, { id, formData }) => {
    commit('UPDATE_STATUS', 'updating');
    try {
      const { data } = await axios.put(`${path}/api/user/${id}/herd`, formData);
      // console.log(data);
      commit('UPDATE', data);
      dispatch(
        'notification/SUCCESS_NOTIFICATION',
        'the item was updated successfully',
        { root: true }
      );
      commit('UPDATE_STATUS', 'success');
    } catch (error) {
      commit('UPDATE_STATUS', 'error');
      dispatch(
        'notification/ERROR_NOTIFICATION',
        'item could not be updated. try again later.',
        { root: true }
      );
    }
  },
  SET_ERROR: ({ commit }, payload) => {
    commit('SET_ERROR', payload.errors);
  },
  CHANGE_DISPLAY_STYLE: ({ commit }, { display }) => {
    commit('UPDATE_DISPLAY_STYLE', { display });
  },
  SORT: ({ commit }, { direction, field }) => {
    commit('SORT_HERDS', { direction, field });
  }
};

const mutations = {
  SORT_HERDS(state, { direction, field = 'name' }) {
    state.sort = { direction, field };

    if (state.items && state.items.length) {
      state.items = sort([...state.items], direction, field);
    }
  },
  UPDATE(state, payload) {
    let current = state.items.find(o => o.id === +payload.id);

    if (current) {
      current = payload;
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations: { ...mutationHelpers, ...mutations }
};
